import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { ApiEndPoints } from "../authentication/api-path";
import { getAPIConfig } from "../authentication/services/get-api-config";
import { ErrorResponse } from "react-router-dom";

export const uploadProfilePhoto = createAsyncThunk(
  "user/uploadProfilePhoto",
  async (file: File, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.UpdateProfile}`;

      const formData = new FormData();
      formData.append("profilePhoto", file);

      // Pass multipart = true
      const { data } = await axios.post(
        url,
        formData,
        await getAPIConfig(true)
      );

      if (data.statusCode === 200) {
        return thunkApi.fulfillWithValue(data); // ✅ return full response
      }

      return thunkApi.rejectWithValue("Unexpected response from server");
    } catch (err) {
      const error = err as AxiosError<ErrorResponse>;
      if (error.response?.data) {
        return thunkApi.rejectWithValue(error.response.data);
      }
      return thunkApi.rejectWithValue(
        "Something went wrong while uploading profile photo."
      );
    }
  }
);


export const getProfilePhoto = createAsyncThunk(
  "contact/getProfilePhoto",
  async (_, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.GetProfilePhoto}`;
      // 👆 yeh endpoint backend me bana tha: /v1/user/profile-photo

      const { data } = await axios.get(url, {
        ...(await getAPIConfig()),
      });

      if (data.profilePhoto) {
        return thunkApi.fulfillWithValue(data);
      }

      return thunkApi.rejectWithValue("No profile photo found.");
    } catch (err) {
      const error = err as AxiosError<ErrorResponse>;
      if (error.response?.data) {
        return thunkApi.rejectWithValue(error.response.data);
      }
      return thunkApi.rejectWithValue("Something went wrong while fetching profile photo.");
    }
  }
);

// ✅ Update User Profile API
export const updateUserProfile = createAsyncThunk(
  "user/updateUserProfile",
  async (payload: any, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.UpdateUserProfile}`;
      // 👆 endpoint backend me tha: PUT /v1/user/update-user-profile

      const { data } = await axios.put(
        url,
        payload,
        await getAPIConfig() // headers + token bhejega
      );

      if (data.statusCode === 200) {
        return thunkApi.fulfillWithValue(data); // ✅ Success
      }

      return thunkApi.rejectWithValue("Unexpected response from server");
    } catch (err) {
      const error = err as AxiosError<ErrorResponse>;
      if (error.response?.data) {
        return thunkApi.rejectWithValue(error.response.data);
      }
      return thunkApi.rejectWithValue(
        "Something went wrong while updating user profile."
      );
    }
  }
);

export const getUserProfile = createAsyncThunk(
  "user/getUserProfile",
  async (_, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.GetUserProfile}`;
      // backend me endpoint: GET /v1/user/user-profile

      const { data } = await axios.get(url, {
        ...(await getAPIConfig()), // Authorization header
      });

      if (data.statusCode === 200) {
        return thunkApi.fulfillWithValue(data);
      }

      return thunkApi.rejectWithValue("Unexpected response from server");
    } catch (err) {
      const error = err as AxiosError<ErrorResponse>;
      if (error.response?.data) {
        return thunkApi.rejectWithValue(error.response.data);
      }
      return thunkApi.rejectWithValue(
        "Something went wrong while fetching user profile."
      );
    }
  }
);

// 🔹 Profile photo delete karne wali API
export const deleteProfilePhoto = createAsyncThunk(
  "user/deleteProfilePhoto",
  async (_, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.DeleteProfilePhoto}`;
      // 👆 endpoint backend me bana tha: /v1/user/delete-profile-photo

      const { data } = await axios.delete(url, {
        ...(await getAPIConfig()), // headers me Authorization token bhejega
      });

      return thunkApi.fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError<ErrorResponse>;
      if (error.response?.data) {
        return thunkApi.rejectWithValue(error.response.data);
      }
      return thunkApi.rejectWithValue("Something went wrong while deleting profile photo.");
    }
  }
);

// 🔹 User Account delete karne wali API
export const deleteUserAccount = createAsyncThunk(
  "user/deleteUserAccount",
  async (payload: { _id: string }, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/v1/user/delete-account`;

      const { data } = await axios.delete(url, {
        data: payload, // 👈 DELETE request me body aise send hoti hai
        ...(await getAPIConfig()), // headers me Authorization token etc.
      });

      return thunkApi.fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError<ErrorResponse>;
      if (error.response?.data) {
        return thunkApi.rejectWithValue(error.response.data);
      }
      return thunkApi.rejectWithValue("Something went wrong while deleting account.");
    }
  }
);
